module.exports = __webpack_public_path__ + "static/media/DSC_3146.cd68f15f.jpg";